import apiEndPoins from "../../utils/apiEndPoints";
import { apiCall } from "../../utils/httpClient";

const getClosingManagerList = async (params) => {
    const data = await apiCall("post", apiEndPoins.CLOSING_MANAGER, params);
    return data;
};

const getClosingManagerDetails = async (params) => {
    const data = await apiCall("post", apiEndPoins.CLOSINGMANAGERDETAILS, params);
    return data;
};

const closingManagerService = {
    getClosingManagerList,
    getClosingManagerDetails
};

export default closingManagerService;